export default () => {
	let scrollEl = $( '.js-scroll-down' );
	let prEl = scrollEl.parent();
	let scrollVal = prEl.offset().top + prEl.outerHeight();

	scrollEl.click( function ( e ) {
		e.preventDefault();
		$( 'body, html' ).animate( {
			scrollTop: `${scrollVal}px`,
		}, 700 );
	} );

	$( '.js-scroll' ).click( function ( e ) {
		e.preventDefault();
		$( 'body, html' ).animate( {
			scrollTop: `${$( this ).offset().top + $( this ).outerHeight()}px`,
		}, 700 );
	} );

	$( window ).scroll( function () {
		let scroll = $( window ).scrollTop();

		if ( scroll >= ( scrollVal - $( window ).innerHeight() ) ) {
			scrollEl.addClass( 'is-hide' );
		} else {
			scrollEl.removeClass( 'is-hide' );
		}
	} );
};
